import { render, staticRenderFns } from "./RuleConfigDialog.vue?vue&type=template&id=335b6d5b&scoped=true&"
import script from "./RuleConfigDialog.vue?vue&type=script&lang=js&"
export * from "./RuleConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./RuleConfigDialog.vue?vue&type=style&index=0&id=335b6d5b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335b6d5b",
  null
  
)

export default component.exports